import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import BusinessPlanScreen from "./BusinessPlanScreen";
import { BusinessPlanScheduleItemUI } from "./tabs/BusinessPlanScheduleItemUI";
import { BusinessPlanScheduleUI } from "./tabs/BusinessPlanScheduleUI";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessSchedule" | "BusinessScheduleItem"
>;

export const BusinessPlanScheduleScreen = observer((props: Props) => {
  return (
    <BusinessPlanScreen {...props}>
      {"itemUid" in props.route.params ? (
        <BusinessPlanScheduleItemUI
          businessPlanUid={props.route.params.businessUid}
          itemUid={props.route.params.itemUid}
        />
      ) : (
        <BusinessPlanScheduleUI
          businessPlanUid={props.route.params.businessUid}
        />
      )}
    </BusinessPlanScreen>
  );
});

export default BusinessPlanScheduleScreen;
